module.exports = __webpack_public_path__ + "static/IS-78bf088a79f73ecefb9afc8c094e2234.mp4";